import React from 'react';
import { excerpt } from '../../../helpers/text/excerpt';
import { IconLabel } from '../../atoms/Texts/IconLabel';
import useStyle from './card.style';

export interface CardLabel {
  text: string;
  backgroundColor?: string;
  icon: 'LabelTag' | 'Clock';
}

export interface CardBodyProps {
  desc?: string;
  labels?: CardLabel[];
}

const CardBody = ({ desc, labels }: CardBodyProps) => {
  const classes = useStyle();

  return (
    <div className={classes.container}>
      <div className={classes.labelTag}>
        {labels &&
          labels.map((label, i) => (
            <IconLabel
              key={i}
              label={label.text}
              icon={label.icon}
              backgroundColor={label.backgroundColor}
            />
          ))}
      </div>

      <p>{excerpt(desc, 150)}</p>
    </div>
  );
};

export default CardBody;
